import { render, staticRenderFns } from "./LastFiveGames.vue?vue&type=template&id=32d0b596&scoped=true&"
import script from "./LastFiveGames.vue?vue&type=script&lang=js&"
export * from "./LastFiveGames.vue?vue&type=script&lang=js&"
import style0 from "./LastFiveGames.vue?vue&type=style&index=0&id=32d0b596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0b596",
  null
  
)

export default component.exports